import { getMessages } from '../../../../../../../store/constants';
import { THUMB_COMMENT_REPLY_SIZE } from '../../../../../../../const';

export const COMMENT_REPLY = getMessages().getText('card_form_comment_reply');
export const COMMENT_QUOTE_AND_REPLY = getMessages().getText('card_form_comment_quote_and_reply');
export const COMMENTS_UNSEEN = getMessages().getText('card_form_comment_unseen');
export const COMMENT_ANIMATION_DURATION = 1300; // также менять в _comment.scss
export const COMMENT_GOOGLE_THUMB_SIZE = `s${THUMB_COMMENT_REPLY_SIZE}`;
